




















































































































































































             import { Component } from "../../../Infrastructure/CorBase/CoreBase";
             import StatisticsDetailBase from "./StatisticsDetailBase";
             import Chart from 'chart.js';


             @Component
             export default class StatisticsDetail extends StatisticsDetailBase {
//                    options = [
//    { value: null, text: 'Please select an option' },
//    { value: 'a', text: 'This is First option' },
//    { value: 'b', text: 'Selected Option', disabled: true },
//    {
//        label: 'Grouped options',
//        options: [
//            { value: { C: '3PO' }, text: 'Option with object value' },
//            { value: { R: '2D2' }, text: 'Another option with object value' }
//        ]
//    }
//]

                 created() {
                     super.initializeRights('COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant');
                     this.createdBase();
                     super.setMainDescription('statistics.description', 'statistics.description');
                 }


                 mounted() {
                     super.mounted();
                 };


                 render() {
                        //@ts-ignore
                     const ctxBar = this.$refs.chartCanvasBarX.getContext('2d');
                     //@ts-ignore
 new Chart(ctxBar, {
     type: 'bar',
     data: {
         labels: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00'],
         datasets: [
             {
                 label: 'Teplota CPU',
                 data: [32, 55, 66, 51, 45, 35],
                 backgroundColor: 'rgba(255, 180, 132, 0.2)',
                 borderWidth: 2
             }
         ]
     }
 });
 }

             }
         